import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=a68d2aee&scoped=true&"
import script from "./FileSelector.vue?vue&type=script&lang=ts&"
export * from "./FileSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=a68d2aee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68d2aee",
  null
  
)

export default component.exports